export function BlockButton({ label, onClick }: { label: string; onClick: () => void }) {
  return (
    <button
      type="button"
      className="flex-1 rounded-lg border border-primary/60 bg-primary/10 px-3 py-2 text-xs font-semibold text-primary shadow-sm transition-all duration-200 hover:border-primary hover:bg-primary/20"
      onClick={onClick}
    >
      {label}
    </button>
  );
}
